<template>
    <div class="templete_box">
        <div class="templete no_print">
            <div class="search_box clearfix">
                <div class="search_time search_inputBox">
                    <el-date-picker v-model="sales_time" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="销售日期"></el-date-picker>
                </div>
                <el-input class="search_input search_inputBox" v-model="params.search.order_sn" placeholder="销售单号"></el-input>
                <select-down-customer ref="selectdowncustomer" class="searchCustomer" @changeselect="res=>{this.params.search.customer_id = res;}"></select-down-customer>
                <!-- <el-select class="search_select search_inputBox" v-model="params.search.status" placeholder="订单状态">
                    <el-option v-for="list in statusList" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select> -->
                <el-select class="search_select search_inputBox" v-model="params.search.salesman_id" placeholder="销售人" @visible-change="getSelectList('user')">
                    <el-option v-for="list in selectMap.user" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <!-- <el-select class="search_select search_inputBox" v-model="params.search.status">
                        <el-option value="3" label="已审核"></el-option>
                        <el-option value="4" label="未审核"></el-option>
                </el-select> -->
                <el-select class="search_select search_inputBox" size="mini" multiple collapse-tags v-model="params.search.status"
                placeholder="审核状态" >
                        <el-option value="4" label="已审核"></el-option>
                        <el-option value="3" label="未审核"></el-option>
                </el-select>
                <div class="reset fcolor" @click="reset">重置</div>
                <el-button  class="publicBtn" @click="getList(true)">查询</el-button>
                 <div class="execlInsert execlInsertHasFilter clearfix">
                    <div class="sousuoBtn" @click="openSou"></div>
                    <div class="filterBtn" @click="filterDialogVisible=!filterDialogVisible"></div>
                </div>
            </div>
            <div class="tableBox">
                <tabletem :isSetCol="true" scene="order.review.list" :isLoading="tableLoading" :tablecol="tableCol" :tabledata="list" @getRow="getRow" @rowClick="rowClick" @getTransfer="getTransfer" @sortTable="sortList"></tabletem>
            </div>
            <div class="pageBox">
                <pagination ref="pagination" :lastpages.sync="last_page" :currentpages.sync="params.page" :all.sync="total" :pagesizes.sync="params.per_page" @getPage="getPage"></pagination>
            </div>
        </div>
        <!-- dialog START -->
        <sale-bill-base ref="saleBillBase" :dialog="dialogVisible" @hide="dialogVisible=false"
                        :dt="orderType" :source="'review'" :form-data="detailInfo" :scene="'order.update.review'"
                        @bill="syncBill">
            <div class="editBtnList clearfix" v-if="orderType===3">
                <div class="editTax clearfix">
                    <div class="" style="margin-bottom: 10px">
                        <div class="editTaxname">客户欠款：{{bill.unbalance}}</div>
                    </div>
                    <div class="" style="margin-bottom: 10px" v-if="module.includes('sell-review-show-margin')">
                        <div class="editTaxname" style="text-indent:12px">毛利率：{{detailInfo.margin_rate}}</div>
                    </div>
                </div>
                <div class="editTax clearfix">
                    <div class="" style="margin-bottom: 10px" v-if="billColumns.includes('min_price')">
                        <!-- <div class="editTaxname">对比率：{{totalObj.compare_rate}}</div> -->
                        <div class="editTaxname">金额差：
                            <span v-if="totalObj.amount_sub>=0" style="color: green;">{{totalObj.amount_sub}}</span>
                            <span v-if="totalObj.amount_sub<0" style="color: red;">{{totalObj.amount_sub}}</span>
                        </div>
                    </div>
                    <div class="" style="margin-bottom: 10px" v-if="module.includes('sell-review-show-margin')">
                        <div class="editTaxname">毛利润：{{detailInfo.profit}}</div>
                    </div>
                </div>
                <!-- <div class="editTax clearfix" style="margin-bottom: 10px" v-if="billColumns.includes('min_price')">
                    <div class="editTaxname">金额差：{{totalObj.amount_sub}}</div>
                </div> -->
                
                <div style="float:left;margin-bottom: 10px">
                    <div v-if="newFee.length>0" class="clearfix" style="float:left;">
                        <div class="newFee" v-for="(list,index) in newFee" :key="'_'+index">
                            {{list.fee_name+':  ￥'+list.amount}}
                        </div>
                    </div>
                </div>
                <div class="editBtn" style="margin-bottom: 10px">
                    <el-button class="funcPublicBtn" v-if="module.includes(',sell-review-update,')&&detailInfo.isPassReview" @click="editSale">修改</el-button>
                    <el-button class="funcPublicBtn" v-if="detailInfo.isPassReview" @click="centerDialogVisible=!centerDialogVisible">审核拒绝</el-button>
                    <el-button class="funcPublicBtn funcPublicBtnChecked" v-if="detailInfo.isPassReview" @click="examine">审核通过</el-button>
                </div>
            </div>
            <div class="editBtnList clearfix" v-if="orderType===2">
                <div style="float:left;margin-bottom: 10px">
                    <el-button class="funcPublicBtn" style="line-height: 25px;" v-if ="module.includes(',finance-fee-manage-add,')" @click="openbusinessRelation">关联销售费用</el-button>
                    <div v-if="newFee.length>0" class="clearfix" style="float:left;">
                        <div class="newFee" v-for="(list,index) in newFee" :key="'_'+index">
                            {{list.fee_name+':  ￥'+list.amount}}
                             <img src="../../assets/top-delete-suspension.png" class="newFeeImg" @click="delOutFee(index)"/>
                        </div>
                    </div>
                </div>
                <div class="editBtn" style="margin-bottom: 10px">
                    <el-button class="funcPublicBtn funcPublicBtnChecked" style="width:125px;" @click="save(1)">保存修改并审核通过</el-button>
                </div>
            </div>
        </sale-bill-base>
        <!-- dialog END -->
        <!--拒绝原因START-->
        <el-dialog v-dialog-drag title="拒绝原因" :visible.sync="centerDialogVisible" width="500px" class="eldialog eldialogA" :model="false">
            <textarea class="edit_input edit_textarea" v-model="refuse.refuse_remark" placeholder="请输入拒绝原因"></textarea>
            <div class="dialogBtnList clearfix">
                <el-button  class="publicBtn dialogBtn"  @click="confirmRefuseRemark">确定</el-button>
                <el-button class="dialogBtn funcPublicBtn" @click="centerDialogVisible = false">取消</el-button>
            </div>
		</el-dialog>
        <!--拒绝原因END-->
        <!--添加费用START-->
        <el-dialog v-dialog-drag :visible.sync="businessRelation" class="eldialog eldialogLine" :modal="false" title="添加营业外支出费用" custom-class="full_dialog">
            <div class="dialogSearchBox">
                <el-form ref="feeOutForm" :model="businessRelationForm" :rules="feeOutFormRlues" class="clearfix dialogFormB">
                    <el-form-item  label="日期：" prop="fee_date">
                        <el-date-picker v-model="businessRelationForm.fee_date" type="date" placeholder="" size="mini"></el-date-picker>
                    </el-form-item>
                    <el-form-item  label="销售单号：" v-if="detailInfo.id">
                        <el-input v-model="businessRelationForm.order_sn" readonly></el-input>
                    </el-form-item>
                    <el-form-item  label="费用名称：" prop="fee_id">
                        <el-select v-model="businessRelationForm.fee_id" @input="outFeeChange" @visible-change="outFeeSelectFunc" clearable>
                            <el-option v-for="list in outFeeSelect" :key="list.id" :value="list.id" :label="list.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item  label="收款人(单位)：" prop="payee">
                        <el-input v-model="businessRelationForm.payee"></el-input>
                    </el-form-item>
                    <el-form-item  label="金额(￥)：" prop="amount">
                        <el-input v-model="businessRelationForm.amount"></el-input>
                    </el-form-item>
                    <el-form-item  label="提供发票：" prop="is_invoice">
                        <el-select v-model="businessRelationForm.is_invoice">
                            <el-option value="1" label="是"></el-option>
                            <el-option value="0" label="否"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item  label="备注：" prop="remark">
                        <el-input v-model="businessRelationForm.remark"></el-input>
                    </el-form-item>
                    <div class="elFormBoxBtnListCol">
                        <el-button class="funcPublicBtn" @click="businessRelation=false" style="margin-right:15px!important;">取消</el-button>
                        <el-button class="funcPublicBtn funcPublicBtnChecked" v-if="detailInfo.id" @click="saveOutFee">确认</el-button>
                        <el-button class="funcPublicBtn funcPublicBtnChecked" v-else @click="newOutFee">确认</el-button>
                    </div>
                </el-form>
            </div>
        </el-dialog>
        <!--添加费用END-->
        <!--弹框确认提交审核是否同步销售日期和审核日期为同一天-->
        <el-dialog v-dialog-drag :title="isShowDiffDateCheckBox?'是否确定提交审核?':'提示'" :visible.sync="submitConfirmDialog" width="380px" class="eldialog cDiaC" :model="false">
            <el-checkbox v-model="is_current_time " v-if="isShowDiffDateCheckBox"
                         class="confirmCheckBox">销售日期和提交审核日期不是同一天，是否要将销售日期变更为提交审核日期?
            </el-checkbox>
            <span v-if="!isShowDiffDateCheckBox" class="confirmSpan">是否确定提交审核？</span>
            <div class="dialogBtnList clearfix">
                <el-button  class="publicBtn dialogBtn" @click="confirmSubmit">确定</el-button>
                <el-button class="dialogBtn funcPublicBtn" @click="submitConfirmDialog=false">取消</el-button>
            </div>
        </el-dialog>
        <el-dialog v-dialog-drag title="客户信息" class="eldialog eldialogA" :visible.sync="customerDetail" :model="false" custom-class="full_dialog">
            <div class="">
                <el-form :model="form_params" :rules="rules" ref="edit_form" style="overflow-y: auto;max-height: 600px;">
                    <div class="dialog_path_title eldialogFormTag">基本信息</div>
                    <div class="eldialogFormBox clearfix">
                        <el-form-item label="公司名称：" prop="name">
                            <el-input class="edit_input" v-model="form_params.name" placeholder="" :disabled="isSeeEdit"></el-input>
                        </el-form-item>
                        <el-form-item label="公司地址：" prop="address">
                            <el-input class="edit_input" v-model="form_params.address" placeholder="" :disabled="isSeeEdit"></el-input>
                        </el-form-item>
                        <el-form-item label="所属人：" prop="salesman_name">
                            <el-input class="edit_input" v-model="form_params.salesman_name" placeholder="" :disabled="isSeeEdit"></el-input>
                        </el-form-item>
                        <el-form-item label="电话/传真：" prop="fax">
                            <el-input class="edit_input" v-model="form_params.fax" placeholder="" :disabled="isSeeEdit"></el-input>
                        </el-form-item>
                        <el-form-item label="工厂规模：" prop="factory_size">
                            <el-input class="edit_input" v-model="form_params.factory_size" placeholder="" :disabled="isSeeEdit"></el-input>
                        </el-form-item>
                        <el-form-item label="厂房信息：" prop="factory_size">
                            <el-input class="edit_input" v-model="form_params.factory_info" placeholder="" :disabled="isSeeEdit"></el-input>
                        </el-form-item>
                        <el-form-item label="采购木种：" prop="wood_category">
                            <el-input class="edit_input" v-model="form_params.wood_category" placeholder="" :disabled="isSeeEdit"></el-input>
                        </el-form-item>
                        <el-form-item label="其他信息：" prop="other_info">
                            <el-input class="edit_input" v-model="form_params.other_info" placeholder="" :disabled="isSeeEdit"></el-input>
                        </el-form-item>
                    </div>
                    <div class="eldialogFormBox clearfix">
                        <el-form-item label="所在省份：" prop="province_name">
                            <el-input class="edit_input" v-model="form_params.province_name" placeholder="" :disabled="isSeeEdit"></el-input>
                        </el-form-item>
                        <el-form-item label="所在城市：" prop="city_name">
                            <el-input class="edit_input" v-model="form_params.city_name" placeholder="" :disabled="isSeeEdit"></el-input>
                        </el-form-item>
                        <el-form-item label="客户属性：" prop="customer_attribute_name">
                            <el-input class="edit_input" v-model="form_params.customer_attribute_name" placeholder="" :disabled="isSeeEdit"></el-input>
                        </el-form-item>
                        <el-form-item label="客户来源：" prop="customer_source_name">
                            <el-input class="edit_input" v-model="form_params.customer_source_name" placeholder="" :disabled="isSeeEdit"></el-input>
                        </el-form-item>
                        <el-form-item label="主营项目：" prop="main_business">
                            <el-input class="edit_input" v-model="form_params.main_business" placeholder="" :disabled="isSeeEdit"></el-input>
                        </el-form-item>
                        <el-form-item label="信用指数：" prop="star">
                            <el-select class="edit_input" v-model="form_params.star" :disabled="isSeeEdit">
                                <el-option :value="1" :label="'一星'"></el-option>
                                <el-option :value="2" :label="'二星'"></el-option>
                                <el-option :value="3" :label="'三星'"></el-option>
                                <el-option :value="4" :label="'四星'"></el-option>
                                <el-option :value="5" :label="'五星'"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="客户文件：" v-if="form_params.files">
                            <span style="float: left;font-size: 12px;color: #b21111;" @click="openFile">资料查看</span><img  @click="openFile" class="file" src="/icon/file.png">
                        </el-form-item>
                        <el-form-item v-else>
                        </el-form-item>
                        <div class="mark">
                            <el-form-item label="备注：" prop="remark">
                                <!-- <el-input class="edit_input" v-model="form_params.remark" placeholder=""></el-input> -->
                                <div class="content_box">
                                    <span class="content">{{form_params.remark}}</span>
                                    <span class="edit cursorPointer" :disabled="isSeeEdit" @click="markEdits"></span>
                                </div>
                            </el-form-item>
                        </div>
                    </div>
                    <div class="dialog_path_title eldialogFormTag">联系方式</div>
                    <template v-for="(item,index) in form_params.contacts">                
                        <div :class="['link_item', index == 0 ? '':'add_item']" :key="index">
                            <div class="eldialogFormBox clearfix">
                                <el-form-item label="联系人：" :prop="`contacts[${index}].contact`" :rules="{ required: true, message: '必填项', trigger: 'change' }">
                                    <el-input v-model="item.contact" class="edit_input" :disabled="isSeeEdit"></el-input>
                                </el-form-item>
                                <el-form-item label="联系电话：" :prop="`contacts[${index}].phone`" :rules="{ required: true, message: '必填项', trigger: 'change' }">
                                    <el-input v-model="item.phone" class="edit_input" :disabled="isSeeEdit"></el-input>
                                </el-form-item>            
                            </div>
                            <div class="eldialogFormBox clearfix">
                                <el-form-item label="微信：">
                                    <el-input v-model="item.wechat" class="edit_input" :disabled="isSeeEdit"></el-input>
                                </el-form-item>
                                <el-form-item label="电子邮箱：">
                                    <el-input v-model="item.email" class="edit_input" :disabled="isSeeEdit"></el-input>
                                </el-form-item>
                            </div>
                            <!-- <div :class="['item_icon','cursorPointer',index == 0 ? 'add_icon':'del_icon']"  @click="addOrDelete(index)"></div> -->
                        </div>
                    </template>    
                    <div class="dialog_path_title eldialogFormTag">开票资料</div>
                    <div class="eldialogFormBox eldialogFormTag clearfix">
                        <el-form-item label="名称：" prop="invoice_name" style="margin-top: 21px;">
                            <el-input class="edit_input" v-model="form_params.invoice_name" placeholder="" :disabled="isSeeEdit"></el-input>
                        </el-form-item>
                        <el-form-item label="开户行：" prop="invoice_bank_name" style="margin-top: 21px;">
                            <el-input class="edit_input" v-model="form_params.invoice_bank_name" placeholder="" :disabled="isSeeEdit"></el-input>
                        </el-form-item>
                    </div>
                    <div class="eldialogFormBox eldialogFormTag clearfix">
                        <el-form-item label="税号：" prop="invoice_no">
                            <el-input class="edit_input" v-model="form_params.invoice_no" placeholder="" :disabled="isSeeEdit"></el-input>
                        </el-form-item>
                        <el-form-item label="账号：" prop="invoice_bank_no">
                            <el-input class="edit_input" v-model="form_params.invoice_bank_no" placeholder="" :disabled="isSeeEdit"></el-input>
                        </el-form-item>
                    </div>
                    <div class="eldialogFormBox eldialogFormTag clearfix">
                        <el-form-item label="地址：" prop="invoice_addr">
                            <el-input class="edit_input" v-model="form_params.invoice_addr" placeholder="" :disabled="isSeeEdit"></el-input>
                        </el-form-item>
                        <el-form-item label="电话：" prop="invoice_phone">
                            <el-input class="edit_input" v-model="form_params.invoice_phone" placeholder="" :disabled="isSeeEdit"></el-input>
                        </el-form-item>
                    </div>
                </el-form>
            </div>
            <div class="dialogBtnList clearfix">
                <!-- <el-button  class="publicBtn dialogBtn" @click="addCustomer">确定</el-button> -->
                <el-button class="dialogBtn funcPublicBtn" @click="customerDetail=!customerDetail">关闭</el-button>
            </div>
        </el-dialog>
        <el-dialog title="备注" :visible.sync="markDialogVisibles" class="eldialog mark_dialog" width="350px" :modal="false" :before-close="markhandleCloses" v-dialogDrag>
            <div>
                <el-input type="textarea" :rows="5" placeholder="请输入内容" maxlength=100 v-model="form_params.remark" :disabled="isSeeEdit"></el-input>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button class="sm_confirm_btn" type="primary" size="small" @click="markDialogVisibles=false">确认</el-button>
            </span>
        </el-dialog>
        <!-- 搜索弹框 -->
        <el-dialog title="客户搜索" :visible.sync="customerDialogVisibles" class="eldialog mark_dialog" width="350px" :modal="false" :before-close="customerCloses" v-dialogDrag>
            <div style="padding:10px;">
                <el-input placeholder="请输入客户名称" maxlength=100 v-model="params.search.customer_name"></el-input>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button class="sm_confirm_btn" type="primary" size="small" @click="Customerion()">确认</el-button>
            </span>
        </el-dialog>
        <!-- 字段过滤 START -->
        <filter-fields :tableData="filter" scene="order.review.list" :filterDialogVisible="filterDialogVisible" @confirm="filterConfirm" @dialogChangeFunc="val=>{this.filterDialogVisible = val;}"></filter-fields>
        <!-- 字段过滤 END -->
    </div>
</template>
<script>
    import tabletem from '../../components/table.vue';
    import pagination from '../../components/pagination.vue';
    import selectDownCustomer from '../../components/selectDownCustomer.vue';
    import saleBillBase from '../../components/saleBillBase';

    const initSearchParams = {
        search:{
            order_sn:"",
            sales_time:"",
            start_time:"",
            end_time:"",
            customer_id:"",
            salesman_id:"",
            status:[],
            customer_name:""
        },
        page:1,
        per_page:50
    };
    const initBusinessRelationForm = {
        order_id: "",
        order_sn: "",
        fee_date: "",
        fee_id: "",
        fee_name: "",
        payee: "",
        amount: "",
        is_invoice: "",
        remark: ""
    };
    export default {
        data(){
            return{
                orderType: 3,
                detailInfo: {},
                tableLoading:false,
                businessRelation:false,
                businessRelationForm: this.$cloneJson(initBusinessRelationForm),
                outFeeSelect:[],
                feeOutFormRlues:{
                    fee_date:[ { required: true, message: '请填写日期', trigger: 'blur' }],
                    order_id:[ { required: true, message: '请选择销售单号', trigger: 'blur' }],
                    fee_id:[ { required: true, message: '请选择费用名称', trigger: 'blur' }],
                    payee:[ { required: true, message: '请填写收款人', trigger: 'blur' }],
                    amount:[ { required: true, message: '请填写金额', trigger: 'blur' }],
                    is_invoice:[ { required: true, message: '请选择是否开票', trigger: 'blur' }],
                },
                is_current_time: true,//是否使用当前时间 （0否 1是）
                isShowDiffDateCheckBox: true,//是否显示checkbox
                submitConfirmDialog: false,//对话框
                submitConfirmType: '',//确认提交类型
                batchSubIds: [],

                module:localStorage.dw_erp_power_code,
                enableConfig:localStorage.dw_erp_enable_config,
                boardAmericaType:localStorage.dw_erp_board.includes("board-america"),
                boardAfricaType:localStorage.dw_erp_board.includes("board-africa"),
                categoryRawType:localStorage.dw_erp_category.includes("raw"),
                categoryBoardType:localStorage.dw_erp_category.includes("board"),
                dialogVisibleRelation:false,

                printCustomer:"",
                printSale:"",
                companyName:localStorage.dw_erp_company_name,
                sales_time:"",
                refuse:{
                    id:"",
                    refuse_remark:""
                },
                params:this.$cloneJson(initSearchParams),
                bill:{},
                dialogVisible:false,
                centerDialogVisible:false,
                dialogVisibleWidth:false,
                filterDialogVisible:false,
                filter:[],
                billColumns:"",
                widthList:[],
                last_page:1,
                total:0,
                selectRow:[],
                selectMap:{
                    user:[],
                    customer:[],
                    paymentType:[],
                    account:[],
                    lockLevel:[]
                },
                statusList:[
                    {id:1,name:"锁定中"},
                    {id:2,name:"销售审核被拒绝"},
                    {id:3,name:"等待销售审核"},
                    {id:4,name:"等待财务审核"},
                    {id:5,name:"等待出库"},
                    {id:6,name:"部分出库"},
                    // {id:7,name:"全部出库"}
                ],
                list:[],
                tableCol:[	
                    {colName:"销售状态",colKey:"status_text",colWidth:100},
                    {colName:"销售日期",isDate:true,colKey:"sales_time",colWidth:100,isSort:true},
                    {colName:"审核时间",isFullDate:true,colKey:"sell_audit_time",colWidth:100,isSort:true},
                    {colName:"销售单号",colKey:"order_sn",colWidth:190,isCanClick:true},
                    {colName:"客户名称",colKey:"customer_name",colWidth:170,isSetWidth:true,isCanClickNoColor:true,isColor:true,isHideShowClickImg:true,},
                    {colName:"件数",colKey:"count",colWidth:80},
                    {colName:"销售立方",colKey:"sales_cube",colWidth:80},
                    {colName:"销售金额",colKey:"sales_amount",colWidth:80},
                    {colName:"销售人",colKey:"salesman_name",colWidth:80},
                    {colName:"审核人",colKey:"auditor_name",colWidth:80},
                    {colName:"制单人",colKey:"creator_name",colWidth:80},
                    {colName:"备注",colKey:"remark",colWidth:150}
                ],
                totalObj:{},
                newFee:[],
                customerDetail:false,
                form_params : {
                    id:"",
                    name : "",
                    salesman_id : "",
                    // linkman : "",
                    // phone : "",
                    address : "",
                    province_id : "",
                    city_id : "",
                    // email : "",
                    main_business : "",
                    remark : "",
                    // wechat: "",
                    fax: "",
                    customer_attribute_id: "",
                    customer_source_id: "",
                    star:"",
                    invoice_name:"",
                    invoice_no:"",
                    invoice_bank_name:"",
                    invoice_bank_no:"",
                    invoice_addr:"",
                    invoice_phone:"",
                    factory_size:"",
                    factory_info:"",
                    wood_category:"",
                    other_info:"",
                    contacts:[
                         {contact: '', phone:'', wechat: '', email: ''}
                    ],
                },
                rules: {
                    name : [ { required: true, message: '请输入公司名称', trigger: 'blur' } ],
                    address : [ { required: true, message: '请输入公司地址', trigger: 'blur' } ],
                    salesman_id : [ { required: true, message: '请选择归属人', trigger: 'blur' } ],
                    // linkman : [ { required: true, message: '请输入联系人', trigger: 'blur' } ],
                    // phone : [ {required: true,  message: '请输入联系电话', trigger: 'blur' } ]
                },
                isSeeEdit:false,
                proList:[],
                cityList:[],
                cityListS:[],
                markDialogVisibles:false,
                customerDialogVisibles:false,
            }
        },
        created(){
            this.tableColCopy = this.$deepClone(this.tableCol);
            this.getList();
        },
        methods:{
            //备注编辑
            markEdits(){
                this.markDialogVisibles = true
                this.markCopy = this.form_params.remark
            },
            //弹窗关闭回调
            markhandleCloses(){
                this.markDialogVisibles=false 
                this.form_params.remark = this.markCopy
            },
            openFile(){
                 window.open(this.form_params.files)
            },
            sortList(e) {
                this.$generalSortParams(this.params, e);
                this.getList();
            },
            getTransfer(id){
                sessionStorage.setItem("FINISHED_PRODUCT_ORDER_ID",id)
                this.$root.$children[0].$children[0].addTab({
                    name: '板材调货管理'+id,
                    label: '板材调货管理',
                    content: 'purchaseCondimentsList'
                });
            },
            editSale(){
                this.orderType = 2;
                this.detailInfo = this.$cloneJson(this.detailInfo);
                this.detailInfo.saleOrderIsEdit = true;
            },
            openbusinessRelation(){
                this.businessRelationForm.order_id = this.detailInfo.id;
                this.businessRelationForm.order_sn = this.detailInfo.order_sn;
                this.businessRelation = true;
                this.businessRelationForm.fee_date = this.sales_time;
            },
            outFeeChange(e){
                this.outFeeSelect.forEach(item=>{
                    if(Number(item.id)===Number(e)){
                        this.businessRelationForm.fee_name = item.name;
                    }
                })
            },
            outFeeSelectFunc(){
                this.postFunc("/erp/purchase.cost.type",{type:2},res=>{
                    this.outFeeSelect=res.data.data;
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            newOutFee(){
                for(let key in this.businessRelationForm){
                    if(this.businessRelationForm[key]===""){
                        if(['order_id','order_sn','remark'].includes(key)){
                            // this.pl(key)
                        }else{
                            this.tip("请填写完整信息","warning")
                            return;
                        }
                    }
                }
                // let time = this.businessRelationForm.fee_date;
                this.businessRelationForm.fee_date=this.formatTimeZero(this.businessRelationForm.fee_date);
                this.newFee.push(this.$cloneJson(this.businessRelationForm));
                this.businessRelation=false;
            },
            saveOutFee(){
                for(let key in this.businessRelationForm){
                    if(this.businessRelationForm[key]===""){
                        if(key!=="remark"){
                            this.tip("请填写完整信息","warning")
                            return;
                        }
                    }
                }
                let time = this.businessRelationForm.fee_date;
                this.businessRelationForm.fee_date=this.formatTimeZero(this.businessRelationForm.fee_date);
                this.postFuncLoading("/erp/order.add.fee",this.businessRelationForm,()=>{
                    this.businessRelation=!this.businessRelation;
                    this.tip("添加成功","success")
                    this.newFee.push(this.$cloneJson(this.businessRelationForm));
                },error=>{
                    this.businessRelationForm.fee_date = time;
                    this.tip(error.data.message,"warning")
                })
            },
            delOutFee(ind){
                this.newFee.forEach((item,index)=>{
                    if(index===ind){
                        this.newFee.splice(index,1)
                    }
                })
            },
            confirmSubmit() {
                if (this.submitConfirmType === 'batchSubmit') {
                    let ids = this.batchSubIds;
                    this.postFuncLoading("/erp/order.req.review", {
                        ids: ids.toString(),
                        is_current_time: Number(this.is_current_time)
                    }, () => {
                        this.submitConfirmDialog = false;
                        this.tip('提交审核成功', 'success');
                        this.getList();
                    }, error => {
                        this.tip(error.data.message, "warning");
                    });
                }else if (this.submitConfirmType === 'dialogSubmit') {
                    this.save(1, true);
                }

            },
            save(type, skipCheck = false) {
                let $baseRef = this.$refs.saleBillBase;
                $baseRef.$refs["saleorderA"].validate((valid) => {
                    if (valid) {
                        $baseRef.$refs["saleorderB"].validate((validC) => {
                            let _params = this.$cloneJson($baseRef.form_params);
                            let _listDetail = this.$cloneJson($baseRef.listDetail);
                            if (validC) {
                                let url = "/erp/order.update.review";
                                _params.fee_list = this.newFee;
                                if(_params.rec_type==2){
                                    _params.rec_type = 'DIV'
                                }else{
                                    _params.rec_type = 'MUL'
                                }
                                _params.rec = _params.rec ? 1 : 0;
                                _params.is_show_traffic = _params.is_show_traffic ? 1 : 0;
                                _params.is_discount_rate = _params.is_discount_rate ? 0 : 0;
                                _params = this.$changeTimeParams(_params, ['sales_time', 'predict_time', 'delivery_time']);
                                let inventory_list = [];
                                let cloud_list = [];
                                _listDetail.forEach(item => {
                                    if (item.inventory_cloud_id) {
                                        cloud_list.push(item)
                                    } else {
                                        inventory_list.push(item)
                                    }
                                });
                                _params.inventory_list = inventory_list;
                                _params.cloud_list = cloud_list;
                                _params.is_request_review = type;
                                if (Number(type) === 1) {
                                    if (skipCheck) {
                                        //跳过检查
                                        _params.is_current_time = Number(this.is_current_time);
                                    }else {
                                        //提交审核时才提示弹框，仅保存时不提示
                                        let hasBeforeDays = this.$isHasBeforeDays([_params], 'sales_time');
                                        if (hasBeforeDays) {
                                            this.submitConfirmType = 'dialogSubmit';
                                            this.isShowDiffDateCheckBox = true;
                                            this.is_current_time = true;//默认勾选
                                            this.submitConfirmDialog = true;
                                            return;
                                        }
                                    }
                                }
                                this.postFuncLoading(url, _params, () => {
                                    this.submitConfirmDialog = false;
                                    this.dialogVisible = false;
                                    this.tip('操作成功', 'success');
                                    this.getList();
                                }, error => {
                                    this.tip(error.data.message, "warning")
                                })
                            } else {
                                return false;
                            }
                        });
                    } else {
                        return false;
                    }
                });
            },
            getSelectList(target){
                this.$getSelectList(target).then(res=>{
                    this.selectMap[res.target]=res.list;
                })
            },
            //拒绝审核通过
            confirmRefuseRemark(){
                this.confirmLog("是否确认拒绝?",()=>{
                    this.postFuncLoading("/erp/order.refuse.review",this.refuse,()=>{
                        this.tip('拒绝成功','success');
                        this.centerDialogVisible=false;
                        this.dialogVisible=false;
                        this.getList()
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                });
            },
            //审核通过
            examine(){
                this.confirmLog("是否确认审核通过?",()=>{
                    this.postFuncLoading("/erp/order.pass.review",{id:this.detailInfo.id},()=>{
                        this.tip('审核成功','success');
                        this.dialogVisible=false;
                        this.getList()
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                });
            },
            syncBill(e) {
                this.bill = e;
            },
            reset(){
                this.sales_time="";
                this.params = this.$cloneJson(initSearchParams);
                this.$refs['selectdowncustomer'].clearData();
                this.getList();
            },
            filterConfirm(){
                this.getList()
            },
            openSou(){
                this.customerDialogVisibles = true
            },
            customerCloses(){
                this.customerDialogVisibles = false;
            },
            Customerion(){
                this.getList();
                this.customerDialogVisibles = false;
                this.params.search.customer_name = '';
            },
            getList(flag){
                if(flag){
                    this.params.page = 1;
                }
                this.params.search.sales_time = this.formatTimeZero(this.sales_time);
                this.tableLoading = true;
                this.$postColumnList("/erp/order.review.list",this.params,res=>{
                    this.filter = res.data.data.column;
                    this.last_page=parseInt(res.data.data.last_page);
                    this.params.page=parseInt(res.data.data.current_page);
                    this.$refs.pagination.flag = true;
                    this.tableLoading = false;
                    this.total=parseInt(res.data.data.total);
                    this.list=res.data.data.list;
                    this.list.forEach((item)=>{
                        item.isDelete=false;
                        item.idEdit=false;
                    })
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },

            getPage(obj){
                this.params.page=obj.currentpage;
				this.params.per_page=obj.pagesize;
            },
            rowClick(obj){
                if(obj.name=='order_sn'){
                    let total_number = 0;
                    this.postFuncLoading("/erp/finance.order", {id: obj.id}, res => {
                        this.orderType = 3;
                        let resD = res.data.data;
                        res.data.data.relate_list.forEach(item =>{
                            if(item.rec == 1){
                                total_number += Number(item.amount);
                            }
                        })
                        resD.tax_rec_amount = total_number;
                        if(resD.rec_type=='DIV'){
                            resD.rec_type = 2
                        }else{
                            resD.rec_type = 1
                        }
                        this.newFee = resD.fee_list;
                        this.detailInfo = resD;
                        this.totalObj = resD.statistic;
                        this.detailInfo.saleOrderIsEdit = false;
                        this.detailInfo.isPassReview = obj.row.isPassReview;
                        this.refuse.id = this.detailInfo.id;
                        this.refuse.refuse_remark = "";
                        this.dialogVisible = true;
                        let subData = this.$refs.saleBillBase;
                        this.bill = subData.bill;
                        this.billColumns = subData.billColumns;
                    }, error => {
                        this.tip(error.data.message, "warning")
                    });
                }

                if(obj.name=='customer_name'){
                     this.postFunc('erp/customer.detail',{id:obj.row.customer_id},resD=>{
                        this.isSeeEdit = true
                        this.customerDetail = true
                        let resData = resD.data.data
                        resData.province_id = resData.province_id === 0 ? '' : resData.province_id
                        resData.city_id = resData.city_id === 0 ? '' : resData.city_id
                        resData.star = resData.star === 0 ? '' : resData.star
                        resData.customer_source_id = resData.customer_source_id === 0 ? '' : resData.customer_source_id
                        resData.customer_attribute_id = resData.customer_attribute_id === 0 ? '' : resData.customer_attribute_id
                        resData.salesman_id = resData.salesman_id              
                        this.form_params = resD.data.data
                    })
                }
            },
            getRow(row){
                this.selectRow=row;
            }
        },
        components:{
            tabletem,
            pagination,
            selectDownCustomer,
            saleBillBase
        },
        watch:{
            "params.page":function(){
                this.getList();
            },
            "params.per_page":function(){
                this.getList();
            },
            "dialogVisible":function(val){
                if(!val){
                    this.refuse = this.resetJson(this.refuse);
                    this.detailInfo = {};
                    this.bill = {};
                    this.billColumns = "";
                    this.totalObj = {};
                    this.newFee = [];
                }
            }
        }
    }
</script>
<style scoped lang="scss">
 .dialog_path_title{text-align: center;font-size:14px; font-weight:bold; line-height:25px; color: #606266;padding-bottom:20px;background-color: #fff;}
    .search_box{padding-right:230px;}
    .execlInsert .excel_btn{display: inline;}
        .link_item{
            // padding-right: 50px;
            // margin:0 37px;      
            // margin-top:20px;
            position:relative;
        .item_icon{      
            position:absolute;
            right: 0px;
            top:26px;
            display: block;
            width: 25px;
            height: 25px;
        }
        .add_icon{           
            background: url(/icon/frame_plus.png) center center no-repeat;
            background-size: 16px 16px;
        }
        .del_icon{
            background: url(/icon/frame_minus.png) center center no-repeat;
            background-size: 16px 16px;
        }
        }
        .add_item{
            border-top: 1px dashed #aaa;
            margin-top: 0px;
            padding-top: 10px;
        }
        .file{
            width: 20px;
            float: left;
            margin-left: 5px;
            margin-top: 1px;
        }
        .mark{
            .content_box{
                width: 140px; 
                border-bottom: 1px solid #DCDFE6;
                display:flex;
                padding-left: 10px;
                .content{
                    flex: 1;
                    display: inline-block;
                    width: 120px;
                    height: 24px;
                    text-align:left;
                    overflow:hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    font-size: 12px;
                }
                .edit{
                    display:inline-block;
                    width:20px;
                    background: url(/icon/operation_edit.png) 100% 65% no-repeat;
                    background-size: 16px 16px;
                }         
            }
        }
    // .print .printTable{}
    .print .title{font-size: 20px;font-weight: 600;padding-bottom:20px;}
    // .print .tablePerson{}
    .print .personBox{float: left;}
    .print .personBox:nth-child(2n){float: right;}
    .print .personBox .person{text-align: left;}
    .print .personBox:nth-child(2n) .person{text-align: right;}
    .print .person{font-size: 14px;}
    // .print .tableBox{}
    .print .table{width:100%;border-collapse:collapse;}
    .print .table td{border:1px solid #ccc;font-size: 14px;padding:5px 0;}
    .print .remarkBox{width:100%;border:1px solid #ccc;border-top:0;box-sizing: border-box;padding:5px 5px 5px 40px;position: relative;}
    .print .remarkBox:before{content:"备注:";position: absolute;font-size: 12px;color: #777;top:7px;left:5px;}
    .print .remarkBox .remarkTextarea{width:100%;border:0;color:#777;height:40px;text-align: left;font-size: 12px;padding:3px 0;}
    // .print .bottom{}
    .print .bottomMess{font-size: 12px;width:33.3%;float: left;padding:5px 0;}
    .print .bottomMess:nth-child(1){text-align: left;}
    .print .bottomMess:nth-child(2){text-align: center;}
    .print .bottomMess:nth-child(3){text-align: right;}
    // dialog START
    .piaoMess{font-size: 12px;color:#777;margin-bottom:10px;}
    .piaoMessC{float: left;width:50%;}
    .bottom_flex{ padding-right: 12px; padding-bottom: 8px; }
    .editPayBox{
        .editPay{width:50%;float: left;height:100px;box-sizing:border-box;padding:10px;}
        .editName{font-size: 12px;color:#777;padding:2px 0;}
        .editPay:nth-child(2n){border-left:1px solid #ccc;}
    }
    .editPersonBox{
        .editPerson{width:33%;float: left;font-size: 12px;color:#777;box-sizing: border-box;padding:5px 0;}
    }
    .editBtnList{padding-top:10px;
        .editTax{float: left;margin-right:20px;}
        .editTaxname{float: left;font-size: 12px;color:#777;line-height: 25px;margin-right:5px;}
        .editTaxinput{float: left;width:100px;}
        .editBtn{float: right;}
    }
    // dialog END
    .confirmCheckBox /deep/ .el-checkbox__input{
        position: relative;
        top: -10px;
    }
    .confirmCheckBox /deep/ .el-checkbox__label{
        display: inline-block;
        width: 320px;
        white-space: pre-wrap;
        text-align: left;
    }
    .cDiaC /deep/ .confirmSpan{
        text-align: left;
        display: block;
    }
    .cDiaC /deep/ .el-dialog__body{
        padding: 20px;
    }
    .cDiaC /deep/ .dialogBtnList{
        padding: 20px 10px 0 10px;
    }
    .cDiaC /deep/ .dialogBtnList .funcPublicBtn,.cDiaC /deep/ .dialogBtnList .publicBtn{
        line-height: 25px;
        padding: 0 10px;
        width: 80px;
    }
    .cDiaC /deep/ .el-dialog__header{
        text-align: left;
    }
    .cDiaC /deep/ .el-dialog__header .el-dialog__title{
        font-size: 15px;
        font-weight: unset;
    }
</style>
